import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const useStyles = makeStyles<
  Theme,
  { random1: number; random2: number; random3: number }
>((theme) => ({
  "@keyframes wave": {
    "0%": {
      scale: 0.9,
    },
    "100%": {
      scale: 1.5,
      opacity: 0.3,
    },
  },
  root: {
    position: "absolute",
    top: "1px",
    left: "1px",
  },
  wave: {
    pointerEvents: "none",
    position: "absolute",
    top: "0px",
    left: "0px",
    width: "48px",
    height: "48px",
    border: `3px solid ${theme.palette.events.successDark}`,
    borderRadius: "50%",
  },
  small: {
    animationName: "$wave",
    animationDuration: ({ random1 }) => `${Math.min(0.5 + random1, 1)}s`,
    animationTimingFunction: "ease-out",
    animationDelay: ({ random1 }) => `${-random1}s`,
    animationIterationCount: "infinite",
    opacity: ({ random3 }) => 0.5 + random3 / 2,
  },
  medium: {
    animationName: "$wave",
    animationDuration: ({ random2 }) => `${Math.min(0.5 + random2, 1)}s`,
    animationTimingFunction: "ease-out",
    animationDelay: ({ random2 }) => `${-random2}s`,
    animationIterationCount: "infinite",
    opacity: ({ random1 }) => 0.5 + random1 / 2,
  },
  large: {
    animationName: "$wave",
    animationDuration: ({ random3 }) => `${Math.min(0.5 + random3, 1)}s`,
    animationTimingFunction: "ease-out",
    animationDelay: ({ random3 }) => `${-random3}s`,
    animationIterationCount: "infinite",
    opacity: ({ random2 }) => 0.5 + random2 / 2,
  },
}));

export default useStyles;
